export default __webpack_public_path__ + "static/media/team1.5130c670.png";